import $ from 'jquery'

$(function(){
  $('.manual-link').click(function(event){
    event.preventDefault();
    const page = $(this).data('page')
    const url = $(this).data('url')
    $('#manual-modal').modal()
    show_manual(page, url)

  })

  const show_manual = function(page, url){ 
  // If absolute URL from the remote server is provided, configure the CORS
    // header on that server.

    // Loaded via script tag, create shortcut to access PDF.js exports.
    const pdfjsLib = window['pdfjs-dist/build/pdf'];

    // The workerSrc property shall be specified.
    pdfjsLib.GlobalWorkerOptions.workerSrc = '//mozilla.github.io/pdf.js/build/pdf.worker.js';

    // Asynchronous download of PDF
    const loadingTask = pdfjsLib.getDocument(url);
    loadingTask.promise.then(function(pdf) {
      
      // Fetch the first page
      const pageNumber = page;
      pdf.getPage(pageNumber).then(function(page) {
        
        const scale = 1.5;
        const viewport = page.getViewport(scale);

        // Prepare canvas using PDF page dimensions
        const canvas = document.getElementById('manual-canvas');
        const context = canvas.getContext('2d');
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        // Render PDF page into canvas context
        const renderContext = {
          canvasContext: context,
          viewport: viewport
        };
        const renderTask = page.render(renderContext);
        renderTask.then(function () {
        });
      });
    }, function (reason) {
      // PDF loading error
      console.error(reason);
    });

  }
})
